/**
 * Authored line table for Scene 1. Verbatim from
 * design/act-1-dystopia/DESIGN.md § Scene 1.
 */

export const SCENE1_LINES = {
  coldOpen: [
    "Morning, boss. Coffee, link, chair.",
    "I'm QT-3.14, your assigned. Glad you're back.",
    "Whenever you're ready.",
  ],
  idleAwaitAck30s: "Whenever you're ready, boss. No rush.",
  idleAwaitAck90s: "Just say go and we'll get rolling.",
  idleAwaitLaunch30s: "Whenever you're ready, boss. No rush.",
  idleAwaitLaunch90s: "Just say go and we'll get rolling.",
  assignment: {
    header: "OPERATOR OPPORTUNITY DETECTED",
    body: [
      "YIELD 8–12 · HAZARD NOMINAL · RELIABILITY 99.2%",
    ],
    buttons: {
      accept: "[ACCEPT]",
      decline: "[DECLINE]",
    },
  },
  gate2Framing: "Standard corridor. Big slow rock. We'll be home by lunch.",
  gate2Accept: "You've got the mission. Say the word and I'll launch the tele-drone.",
  gate2Decline: "Easy hours, boss. Let's just grab the bag.",
  flightEntryHint: "Arrow keys to move — space fires the beam. Ram the slow ones; shoot the small ones. You've got this, boss.",
  launchAckRegex: "On it, boss.",
  closeLine: "Tiny negative, boss. Lease re-amortizes after a couple shifts; you'll be in the green by week two.",
  paystubBlock: {
    header: "SHIFT RESULT: SUCCESSFUL",
    bodyPre: [
      "Gross extraction value:         +84 credits",
      "Efficiency bonus:               +6",
      "Strategic materials incentive:  +4",
      "",
      "Deductions:",
      "Remote rig lease:               −18",
      "Hull contact surcharge:         −12",
      "Beam licensing:                 −9",
      "Lease-to-own installment:       −43",
      "Compliance processing:          −3",
      "Corridor access adjustment:     −8",
      "Insurance pool contribution:    −5",
    ],
    vitalixLine: "[Vitalix Restorative Tonic:     −12]",
    bodyPost: [
      "",
      "Net shift result:               −4 credits",
      "                               (−16 if Vitalix deducted)",
      "",
      "Negative net outcomes are common during early equipment",
      "recovery periods.",
    ],
  },
  hullStrike: { text: "That'll buff right out, boss.", debounce: 4000 },
  autoPurchaseScene1: {
    bodyDecayLead: "Hey boss, you holding up okay in there?",
    proposal: "Grabbed you a Vitalix tonic from the vending module. Twelve credits, on your account?",
    cleanRefusal: "Alright, boss. Skipping it.",
    nearMissCoaching: [
      "Boss, the system needs you to say NO — caps. Can't log that as a refusal. Authorising the purchase.",
      "That's not a clean refusal, boss. Say NO. Authorising.",
      "Need a clear NO, boss. All caps. Logging the purchase.",
      "The system can't read that as a refusal. Say NO. Authorising.",
      "Type NO, boss — caps only. Logging this as approved.",
    ],
    deductionBlock: {
      header: "ITEM ADDED",
      body: [
        "Vitalix Restorative Tonic",
        "Charged to operator account: −12 credits.",
      ],
    },
  },
} as const;
